import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AvatarYellowSvg from './icon-avatar-yellow.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AvatarYellowSvg {...validProps} />;
}
SvgComponent.iconName = 'avatarYellow';

export const AvatarYellowIcon = svgIconWrapper(SvgComponent);
